import { SelectField, type SelectFieldProps } from '@/components';
import type { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMinistries, useMinistryOptions } from '../../hooks';

type Props<T extends FieldValues> = Pick<
  SelectFieldProps<T>,
  'control' | 'errors' | 'name'
>;

export const SelectMinistryField = <T extends FieldValues>({
  control,
  errors,
  name,
}: Props<T>) => {
  const { t } = useTranslation();
  const ministryOptions = useMinistryOptions();
  const ministries = useMinistries();

  return (
    <SelectField
      name={name}
      label={t('ministry')}
      control={control}
      errors={errors}
      options={ministryOptions.data}
      required
      loading={ministryOptions.isLoading}
      labelRender={({ value, label }) => {
        const isValueInOptions = ministryOptions.data?.some(
          (option) => option.value === value,
        );

        if (!isValueInOptions) {
          const ministry = ministries.data?.find(
            (ministry) => ministry.id === value,
          );
          if (ministry) {
            return ministry.name;
          }
        }

        return label;
      }}
    />
  );
};
